(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ncs-text-slang-carousel"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('ncs-slang-carousel')) {
  customElements.define('ncs-slang-carousel', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) { this.start(); return; }
      this.ready = true;
      this.track = this.querySelector('.ncs-drop__track');
      this.tabs = [...this.querySelectorAll('[data-index]')];
      this.toggle = this.querySelector('[data-autoplay]');
      this.index = 0;
      this.motion = matchMedia('(prefers-reduced-motion: reduce)');
      this.paused = this.motion.matches;
      this.hovered = false;
      this.focused = false;
      this.visible = true;
      this.updateToggle();
      this.addEventListener('click', event => {
        const button = event.target.closest('button');
        if (!button) return;
        if (button.hasAttribute('data-autoplay')) {
          this.paused = !this.paused;
          this.updateToggle();
        }
        if (button.hasAttribute('data-index')) this.go(Number(button.dataset.index));
        if (button.hasAttribute('data-step')) this.go(this.index + Number(button.dataset.step));
        this.start();
      });
      this.track.addEventListener('keydown', event => {
        if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;
        event.preventDefault();
        this.go(this.index + (event.key === 'ArrowRight' ? 1 : -1));
      });
      this.track.addEventListener('scroll', () => {
        this.index = Math.max(0, Math.min(Math.round(this.track.scrollLeft / this.track.clientWidth), this.tabs.length - 1));
        this.tabs.forEach((tab, i) => tab.setAttribute('aria-pressed', String(i === this.index)));
      }, { passive: true });
      this.addEventListener('pointerenter', event => {
        if (event.pointerType === 'mouse') { this.hovered = true; this.stop(); }
      });
      this.addEventListener('pointerleave', () => { this.hovered = false; this.start(); });
      this.addEventListener('focusin', () => { this.focused = true; this.stop(); });
      this.addEventListener('focusout', () => {
        setTimeout(() => { this.focused = this.contains(document.activeElement); this.start(); }, 0);
      });
      this.track.addEventListener('pointerdown', () => this.stop());
      this.track.addEventListener('pointerup', () => this.start());
      this.track.addEventListener('pointercancel', () => this.start());
      this.onVisibility = () => this.start();
      document.addEventListener('visibilitychange', this.onVisibility);
      this.motion.addEventListener('change', () => {
        if (this.motion.matches) this.paused = true;
        this.updateToggle();
        this.start();
      });
      this.observer = new IntersectionObserver(entries => {
        this.visible = entries[0].isIntersecting;
        this.start();
      });
      this.observer.observe(this);
      this.addEventListener('shopify:block:select', event => {
        const index = [...this.querySelectorAll('.ncs-drop__slide')].indexOf(event.target);
        if (index >= 0) { this.paused = true; this.updateToggle(); this.stop(); this.go(index); }
      });
      this.start();
    }
    updateToggle() {
      this.toggle.textContent = this.paused ? this.toggle.dataset.play : this.toggle.dataset.pause;
    }
    stop() { clearInterval(this.timer); }
    start() {
      this.stop();
      if (this.paused || this.hovered || this.focused || !this.visible || document.hidden || this.tabs.length < 2) return;
      this.timer = setInterval(() => this.go(this.index + 1), 6500);
    }
    disconnectedCallback() {
      this.stop();
      document.removeEventListener('visibilitychange', this.onVisibility);
      this.observer?.disconnect();
      this.ready = false;
    }
    go(index) {
      this.index = (index + this.tabs.length) % this.tabs.length;
      this.track.scrollTo({left: this.index * this.track.clientWidth, behavior: this.motion.matches ? 'auto' : 'smooth'});
    }
  });
}

  } catch(e) { console.error(e); }
})();
})();
